import { Route, Routes } from "react-router";

import { SinglePageCheckoutRoutes } from "@jti/fe-common";

import { CheckoutFastFlowProvider } from "@checkout-v2/features/checkoutFastFlow/context/CheckoutFastFlowContext";
import { PaymentProvider } from "@checkout-v2/features/payment";
import { MainPage } from "@checkout-v2/pages/MainPage";
import { NotFoundPage } from "@checkout-v2/pages/NotFoundPage";
import { OrderPage } from "@checkout-v2/pages/OrderPage";
import { ThankYouPage } from "@checkout-v2/pages/ThankYouPage";
import { ShippingFormDataProvider } from "@checkout-v2/shared/providers/ShippingFormDataProvider";

import { CheckoutGuard } from "./components/CheckoutGuard";

type SinglePageCheckoutAppRouterProps = {
  onNavigate?: (url: string) => void;
};

export const SinglePageCheckoutAppRouter = ({ onNavigate }: SinglePageCheckoutAppRouterProps) => (
  <Routes>
    <Route
      index
      element={
        <CheckoutGuard onNavigate={onNavigate}>
          <ShippingFormDataProvider>
            <CheckoutFastFlowProvider>
              <PaymentProvider>
                <MainPage />
              </PaymentProvider>
            </CheckoutFastFlowProvider>
          </ShippingFormDataProvider>
        </CheckoutGuard>
      }
    />

    <Route path={SinglePageCheckoutRoutes.orderRootRoute}>
      <Route
        index
        element={
          <PaymentProvider>
            <OrderPage />
          </PaymentProvider>
        }
      />
      <Route
        path={SinglePageCheckoutRoutes.paths.orderPaymentFailed}
        element={
          <PaymentProvider>
            <OrderPage isPaymentFailed />
          </PaymentProvider>
        }
      />
      <Route
        path={`${SinglePageCheckoutRoutes.paths.orderSuccess}/:${SinglePageCheckoutRoutes.params.paymentToken}?`}
        element={<ThankYouPage />}
      />

      <Route path="*" element={<NotFoundPage />} />
    </Route>

    <Route path="*" element={<NotFoundPage />} />
  </Routes>
);
